import React from "react";
import { Grid, Typography, useTheme, useMediaQuery } from "@mui/material";
import mgt from "../../home/assets/image.png";
import LanguageSelector from "./LanguageSelector";

const ResolverHeader = ({ cLogo, pageTitle }) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const terminal = localStorage.getItem("terminal");

  return (
    <>
      <div
        style={{
          boxShadow: !isXs ? "0 2px 4px rgba(0, 0, 0, 0.3)" : "none",
          padding: "0.5em 1em",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {terminal == 4300 ? (
          <img src={mgt} alt="mgt" style={{ height: isXs ? "25px" : "35px" }} />
        ) : (
          cLogo && (
            <img
              src={cLogo}
              alt="cLogo"
              style={{ height: isXs ? "20px" : "30px" }}
            />
          )
        )}

        {!isXs ? (
          <Typography
            color="secondary"
            sx={{
              fontSize: {
                xs: "1rem",
                sm: "1rem",
                md: "1.2rem",
                lg: "1.4rem",
                xl: "1.4rem",
              },
              whiteSpace: "nowrap",
            }}
          >
            {pageTitle}
          </Typography>
        ) : (
          ""
        )}

        <Grid
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <LanguageSelector />
          {terminal == 4300 && (
            <Grid
              item
              xs={4}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              {cLogo && (
                <img
                  src={cLogo}
                  alt="cLogo"
                  style={{ height: isXs ? "20px" : "30px" }}
                />
              )}
            </Grid>
          )}
        </Grid>
      </div>
      {isXs ? (
        <Typography
          color="secondary"
          textOverflow="ellipsis"
          textAlign="center"
          sx={{
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
            fontSize: {
              xs: "1rem",
              sm: "1rem",
              md: "1.2rem",
              lg: "1.4rem",
              xl: "1.4rem",
            },
            whiteSpace: "nowrap",
          }}
          paddingY=".5em"
        >
          {pageTitle}
        </Typography>
      ) : (
        ""
      )}
    </>
  );
};

export default ResolverHeader;
